<template>
    <modal ref="modalCupon" titulo="Cupon" no-adicional>
        <div class="row mx-0 j-center pb-3 border-bottom mb-3">
            <div class="col-10">
                <div class="position-relative">
                    <el-input v-model="buscar" prefix-icon="icon-search f-18" placeholder="Buscar cupon" class="w-100 br-20 input-search-cupon" />
                    <!-- button -->
                    <button type="button" class="btn-buscar f-14 px-3" @click="buscarCupones">
                        Buscar
                    </button>
                </div>
            </div>
        </div>
        <div v-if="cupones.length > 0">
            <div v-for="(data, idx) in cupones" :key="idx" class="row mx-0 j-center mb-3">
                <div class="card-cupon d-flex position-relative cr-pointer" :class="cuponActivo == idx + 1 ? 'border-active' : ''" @click="verCupon( data )">
                    <div class="space-img pr-3 h-100 d-middle">
                        <img v-if="data.descuento_tipo == 1" src="/img/ilustraciones/descount.svg" width="50" height="50" />
                        <img v-else src="/img/ilustraciones/cash.svg" width="50" height="50" />
                    </div>
                    <div class="col px-2">
                        <div class="row mx-0 align-items-end text-purple pt-2">
                            <div v-if="data.descuento_tipo == 1" class="row mx-0 align-items-end text-purple pt-2">
                                <div class="col-auto px-0 f-600 f-30 text-cupon">
                                    {{ data.descuento_nombre }} %
                                </div>
                                <small class="pl-2">
                                    Descuento
                                </small>
                            </div>
                            <div v-else class="row mx-0 align-items-end text-purple pt-2">
                                <div class="col-auto px-0 f-600 f-30 text-cupon">
                                    {{ formatNumero(data.descuento_nombre) }}
                                </div>
                            </div>
                        </div>
                        <p class="text-detail mt-3">
                            {{ data.nombre }}
                        </p>
                        <p class="text-fetch mt-1">
                            Expira: {{ formatearFecha(data.expira) }}
                        </p>
                    </div>
                    <!-- Circulo cupo -->
                    <div :class="`circled-coupon${ cuponActivo == idx + 1 ? '-active' : '' }`" />
                </div>
            </div>
        </div>
        <div v-else class="row mx-0 j-center mb-3">
            <img :src="funImagenGeneral(46)" />
            <span v-if="mensaje != null" class="text-danger w-100 f-15 row mx-0 j-center"> {{ mensaje }} </span>
            <span v-else class="text-danger w-100 f-15 row mx-0 j-center"> No tienes cupones disponibles</span>
        </div>
    </modal>
</template>

<script>
import Cupones from '~/services/cupones/cupones'
import {mapGetters} from 'vuex'
export default {
    data(){
        return {
            buscar: '',
            cuponActivo: null,
            cupones: [],
            detalle_cupon: null,
            mensaje: null
        }
    },
    computed:{
        ...mapGetters({
            usuario: 'auth/obtenerUsuario',
        })
    },
    methods: {
        toggle(){
            this.buscar = ''
            this.mensaje = null
            this.listaCupones(),
            this.$refs.modalCupon.toggle();
        },
        verCupon(item){
            this.detalle_cupon = item
            this.$emit("detalleCupon", this.detalle_cupon)
            this.$refs.modalCupon.toggle();
        },     
        async listaCupones(){
            try {
                let params = {
                    id_tienda : this.usuario.tienda.id
                }
                const { data } = await Cupones.getCuponesCarrito(params);
                this.cupones = data.cupones;
            } catch (e){
                this.errorCatch(e)
            }          
        },
        async buscarCupones(){
            try {
                let params = {
                    id_tienda : this.usuario.tienda.id,
                    caso : 1,
                    codigo: this.buscar
                }
                const { data } = await Cupones.busquedaCuponesCarrito(params);
                if(data.code == 1 || data.code == 2 || data.code ==  3){
                    this.cupones = []
                    this.mensaje = data.respuesta 
                }else{
                    this.cupones = data.cupon
                }
            } catch (e){
                this.errorCatch(e)
            }          
        },
    }
}
</script>
<style lang="scss" scoped>
.button-search{
    height: 44px;
    border-radius: 20px;
}
.btn-buscar{
    background-color: var(--color-general) !important;
    position: absolute;
    right: 4px;
    height: 36px;
    top: 3px;
    border: 0px;
    border-radius: 20px;
    color: #FFFFFF;
    height: 34px;
    &:focus{
        outline: none !important;
    }
}
.card-cupon{
    width: 346px;
    height: 108px;
    border-radius: 12px;
    padding-left: 35px;
    box-shadow: 0px 2px 4px #00000014;
    z-index: 2;
    .circled-coupon{
        width: 44px;
        position: absolute;
        left: -22px;
        top: 31px;
        height: 44px;
        background-color: white;
        z-index: 1;
        border-radius: 50%;
        box-shadow: 1px 0px 4px #00000014;
        &::after{
            content: '';
            position: absolute;
            left: -24px;
            top: -1px;
            z-index: 2;
            height: 44px;
            width: 44px;
            background-color: #FFFFFF
        }
        &-active{
            @extend .circled-coupon;
            border: 1px solid var(--color-general);
        }
    }
    &.border-active{
        border: 1px solid var(--color-general);
    }
    .space-img{
        border-right: dashed 3px #F6F6F6;
    }
    .text-cupon{
        line-height: 29px;
    }
    .text-detail{
        color: #b1b9c1;
    }
    .text-fetch{
        color: #D3D7DB;
    }
}
</style>